import { HttpClinet, baseURL, version } from "./../utils/config";

export const gcAPI = {
  getCategory: () => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/groupmail/getCategory`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  addCategory: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/groupmail/addCategory`,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  editCategory: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/groupmail/editCategory`,
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  deleteCategory: (data) => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/groupmail/deleteCategory`,
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      data,
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
  getCategoryForCreate: () => {
    return HttpClinet({
      url: `${baseURL}/api/${version}/groupmail/getCategoryForCreate`,
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  },
};
